import React from 'react';
import { connect } from 'react-redux';
import { Icon } from 'b3';
import { openModal } from '../../actions/ModalActions';
import QualifyModal from './QualifyModal';
import './clientStatus.less';

@connect(
    state => ({}),
    { openModal }
)
export default class ClientStatus extends React.Component {
    showQualifyModal(){
        this.props.openModal(QualifyModal, {client: this.props.client});
    }    

    render() {        
        var getBadgeClass = (o) => ((o * 100 == 100) ? "clientBadges__badge__percentage--completed" : ((o * 100 == 0) ? "clientBadges__badge__percentage--none" : "clientBadges__badge__percentage--progress"));

        var training = (this.props.client.bookedTraining && this.props.client.hadTraining) ? 1
                   : ( (this.props.client.bookedTraining && ! this.props.client.hadTraining) ? 0.5
                   : 0 );

        return (
            <div className="clientBadges">
                <div className="clientBadges__row">
                    <div className="clientBadges__badge"
                        onClick={this.showQualifyModal.bind(this)}
                        style={{cursor: "pointer"}}
                    >
                        <Icon icon="award-3" />
                        <span className="clientBadges__badge__label">Qualified</span>
                        <div className={getBadgeClass(this.props.client.isQualified) + " clientBadges__badge__percentage"}>
                            {this.props.client.isQualified * 100}%
                        </div>
                    </div>
                    
                    <div className="clientBadges__badge">
                        <Icon icon="setting-gear" />
                        <span className="clientBadges__badge__label">Setup</span>
                        <div className={getBadgeClass(this.props.client.isSetup) + " clientBadges__badge__percentage"}>
                            {this.props.client.isSetup * 100}%
                        </div>
                    </div>
                    
                    <div className="clientBadges__badge">
                        <Icon icon="user-checked-2" />
                        <span className="clientBadges__badge__label">Using</span>
                        <div className={getBadgeClass(this.props.client.isUsing) + " clientBadges__badge__percentage"}>
                            {this.props.client.isUsing * 100}%
                        </div>
                    </div>
                </div>

                <div className="clientBadges__row">
                    <div className="clientBadges__badge">
                        <Icon icon="profile-2" />
                        <span className="clientBadges__badge__label">Demo</span>
                        <div className={getBadgeClass(this.props.client.isQualified) + " clientBadges__badge__percentage"}>
                            {this.props.client.isQualified * 100}%
                        </div>
                    </div>
                    
                    <div className="clientBadges__badge">
                        <Icon icon="artboard" />
                        <span className="clientBadges__badge__label">Training</span>
                        <div className={getBadgeClass(training) + " clientBadges__badge__percentage"}>
                            {training * 100}%
                        </div>
                    </div>
                    
                    <div className="clientBadges__badge">
                        <Icon icon="dollar-bag" />
                        <span className="clientBadges__badge__label">Paying</span>
                        <div className={getBadgeClass(this.props.client.isPaying) + " clientBadges__badge__percentage"}>
                            {this.props.client.isPaying * 100}%
                        </div>
                    </div>
                </div>
            </div>
        );
    }           
}


// WEBPACK FOOTER //
// ./app/components/clients/ClientStatus.js